import React, { useState } from 'react';
import { Box, CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { OutputLanguage } from '../services/contentService';

const Layout: React.FC = () => {
  // State for language
  const [language, setLanguage] = useState<OutputLanguage>(OutputLanguage.English);
  
  // Handle language change
  const handleLanguageChange = (newLanguage: OutputLanguage) => {
    setLanguage(newLanguage);
    // In a real implementation, you might want to store this in localStorage or a context
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, rgba(18, 18, 18, 0.95) 0%, rgba(0, 0, 0, 0.95) 100%)',
        backgroundAttachment: 'fixed',
        color: 'text.primary'
      }}
    >
      <CssBaseline />
      <Header 
        currentLanguage={language}
        onLanguageChange={handleLanguageChange}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2
        }}
      >
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
